import {FeatureFlags} from './types';

let featureFlags: FeatureFlags = {
  areWalletPaymentsEnabled: false,
};

export function setFeatureFlags(newFeatureFlags?: FeatureFlags) {
  featureFlags = newFeatureFlags ?? {};
}

export function getFeatureFlags(flag: keyof FeatureFlags) {
  return featureFlags[flag];
}
